import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _ProcessFactoryImp } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProccessTypeConstants } from "../CashRequest/FactoryDocument/SelectProccessTypeConstants";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";



export const ProcessFactoryImp = () => {

    const factoryimp = useDataBean(_ProcessFactoryImp);
    const single = Singleton.getInstance();
    const [ProcessType, setProccesType] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        factoryimp.instance.getProcessFactoryImpCatalog(ProcessType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        factoryimp.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        factoryimp.deleteItemVoid(factoryimp.bean.IDProcessFactoryImp).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        factoryimp.instance.updateProcessFactoryImp(factoryimp.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProcessFactoryImp', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessType', visible: true },
        { title: 'Subtipo de Proceso', property: 'ProcessSubtype', visible: true },
        { title: 'Panel de Firma', property: 'SignAndApprovalPanelName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Configuración de Subprocesos">
            <div className="row">
                <div className="col-md-4">
                    <SelectProccessTypeConstants idSelector={ProcessType} onChange={(e: any) => { setProccesType(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={factoryimp.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SingPanelEditor idSelector={factoryimp.bean.IDSignAndApprovalPanel} onChange={(e) => { console.log(e); factoryimp.setBean({ ...factoryimp.bean, 'IDSignAndApprovalPanel': e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {factoryimp.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}